// extracted by css-extract-rspack-plugin
export default {"Text":"time-bound-filter-warning-module__Text__px0LV","Box":"time-bound-filter-warning-module__Box__nVIFw"};